"use strict";

document.addEventListener("DOMContentLoaded", () => {
  const recipes = document.querySelectorAll(".recipe");

  if (recipes.length > 0) {
    recipes.forEach((recipe) => {
      const buttons = recipe.querySelectorAll(".recipe__tab-button");
      const panels = recipe.querySelectorAll(".recipe__panel");

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const target = button.dataset.tab;

          buttons.forEach((btn) => btn.classList.remove("is-active"));
          panels.forEach((panel) => panel.classList.remove("is-active"));

          button.classList.add("is-active");

          recipe
            .querySelector(`.recipe__panel[data-panel="${target}"]`)
            ?.classList.add("is-active");
        });
      });
    });
  }
});